import banner from "../../../courses/module-2/img6.png";

const modulo6_pt = {
  courseId: "cripto-blockchain",
  id: "modulo-6",
  title: "🧩 MÓDULO 6: DeFi, NFTs e outras palavras estranhas",
  estimatedDuration: "1 hora e 30 minutos",
  format: "Leitura + atividade prática",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo do módulo",
      content: [
        "Compreender os conceitos mais comuns (e confusos) que você encontrará ao explorar o mundo Web3: o que é DeFi, para que servem os NFTs e o que significam termos como DAO, staking ou farming.",
      ],
    },
    {
      id: "que-es-defi",
      navLabel: "O que é DeFi?",
      title: "🧠 O que é DeFi (Finanças Descentralizadas)?",
      content: [
        {
          type: "paragraph",
          text: "DeFi significa Decentralized Finance (Finanças Descentralizadas) e se refere a todo um ecossistema de aplicações financeiras construídas sobre blockchain que não dependem de bancos, governos ou intermediários tradicionais.",
        },
        {
          type: "paragraph",
          text: "Em vez de usar um banco para pedir empréstimos, ganhar juros ou trocar moedas, você faz isso diretamente com outros usuários por meio de “smart contracts”.",
        },
        {
          type: "paragraph",
          text: "📌 Exemplos reais:",
        },
        {
          type: "list",
          items: [
            "Aave: você pode solicitar empréstimos em cripto ou emprestar seus fundos para ganhar juros.",
            "Uniswap: permite trocar tokens sem depender de uma corretora tradicional.",
            "Compound: você deposita criptomoedas e ganha juros automaticamente.",
          ],
        },
        {
          type: "paragraph",
          text: "🧠 Palavra-chave: Smart contract",
        },
        {
          type: "paragraph",
          text: "São programas que são executados automaticamente quando certas condições são cumpridas.",
        },
        {
          type: "paragraph",
          text: "Exemplo: “se Marcos depositar USDC, envie para ele 3% de juros ao ano”.",
        },
      ],
    },
    {
      id: "que-son-nfts",
      navLabel: "O que são NFTs?",
      title: "🎨 O que são NFTs?",
      content: [
        {
          type: "paragraph",
          text: "NFT significa Non-Fungible Token. Diferente de uma criptomoeda como o BTC (que pode ser trocado por outro igual), um NFT é único, como uma obra de arte digital.",
        },
        {
          type: "paragraph",
          text: "🎯 Características:",
        },
        {
          type: "list",
          items: [
            "São certificados digitais de propriedade.",
            "Vivem na blockchain.",
            "Podem representar arte, música, ingressos, itens de jogos, identidades digitais e até objetos físicos.",
          ],
        },
        {
          type: "paragraph",
          text: "📌 Exemplos reais:",
        },
        {
          type: "list",
          items: [
            "NBA Top Shot: vídeos colecionáveis oficiais de jogadas da NBA.",
            "Bored Ape Yacht Club: coleção de artes digitais que virou símbolo de status digital.",
            "Axie Infinity: jogo onde cada criatura usada pelo jogador é um NFT.",
          ],
        },
      ],
    },
    {
      id: "otros-conceptos",
      navLabel: "Outros conceitos",
      title: "🛠 Outros conceitos importantes",
      content: [
        {
          type: "table",
          headers: ["Termo", "O que significa?", "Exemplo real"],
          rows: [
            [
              "Staking",
              "Deixar suas criptos “travadas” para ajudar a validar a rede e receber recompensas.",
              "Fazer staking de ADA no Cardano e ganhar ~5% ao ano.",
            ],
            [
              "DAO",
              "Organização autônoma governada por seus membros com regras registradas na blockchain.",
              "Coletivo de artistas que decide, por voto, quais obras financiar.",
            ],
            [
              "Airdrop",
              "Recompensa gratuita de tokens por participar de um projeto ou utilizar um app.",
              "Você usa uma DApp e recebe tokens novos como bônus.",
            ],
            [
              "Yield farming",
              "Mover seus fundos entre plataformas DeFi para maximizar rendimentos.",
              "Depositar USDC em uma app, sacar e mover para outra com taxas melhores.",
            ],
          ],
        },
      ],
    },
    {
      id: "tabla-resumen",
      navLabel: "Resumo",
      title: "🧩 Tabela-resumo – Conceitos principais da Web3",
      content: [
        {
          type: "table",
          headers: ["Termo", "Definição simples", "Exemplo real ou comparação"],
          rows: [
            [
              "DeFi",
              "Finanças sem bancos",
              "Usar Uniswap no lugar de uma corretora",
            ],
            [
              "NFT",
              "Arquivo digital único",
              "Uma pintura digital que só você possui",
            ],
            [
              "Staking",
              "Travar cripto para receber recompensas",
              "Ganhar 4% ao ano em ADA",
            ],
            [
              "DAO",
              "Comunidade que vota decisões",
              "Coletivo digital que escolhe projetos",
            ],
            ["Airdrop", "Tokens gratuitos", "Ganhar tokens por ser early user"],
            [
              "Yield farming",
              "“Caça” por melhores taxas",
              "Trocar entre apps DeFi para maximizar juros",
            ],
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Recursos",
      title: "📌 Recursos recomendados",
      content: [
        {
          type: "link",
          href: "https://www.binance.com/pt-BR/academy/articles/the-complete-beginners-guide-to-decentralized-finance-defi",
          text: "Binance Academy – DeFi explicado",
        },
        {
          type: "link",
          href: "https://www.binance.com/pt-BR/academy/articles/what-is-an-nft",
          text: "Binance Academy – O que é um NFT",
        },
        {
          type: "link",
          href: "https://www.meioemensagem.com.br/opiniao/nfts-blockchain-dao-e-outros-termos-que-vao-mudar-o-mundo",
          text: "Meio e Mensagem – NFTs, DAOs e mais",
        },
      ],
    },
    {
      id: "quiz",
      navLabel: "Quiz",
      title:
        "📝 Atividade do módulo: Quiz – Você domina o mundo Web3? (DeFi, NFTs e mais)",
      questions: [
        {
          id: "q1",
          question: "O que significa DeFi?",
          options: [
            { key: "a", text: "Design Financeiro Inteligente" },
            {
              key: "b",
              text: "Decentralized Finance (Finanças Descentralizadas)",
            },
            {
              key: "c",
              text: "Defesa Financeira Internacional",
            },
            { key: "d", text: "Desenvolvimento Financeiro Ilimitado" },
          ],
          correct: "b",
        },
        {
          id: "q2",
          question:
            "O que permite fazer uma plataforma DeFi como Aave ou Compound?",
          options: [
            { key: "a", text: "Criar NFTs gratuitamente" },
            {
              key: "b",
              text: "Jogar videogames blockchain",
            },
            { key: "c", text: "Emprestar ou pedir criptomoedas sem um banco" },
            { key: "d", text: "Votar em eleições governamentais" },
          ],
          correct: "c",
        },
        {
          id: "q3",
          question: "O que é um smart contract?",
          options: [
            { key: "a", text: "Um acordo verbal entre usuários" },
            { key: "b", text: "Um PDF com condições legais" },
            {
              key: "c",
              text: "Um programa que executa automaticamente regras pré-definidas",
            },
            { key: "d", text: "Um NFT exclusivo para colecionadores" },
          ],
          correct: "c",
        },
        {
          id: "q4",
          question: "Qual dos seguintes é um exemplo de NFT?",
          options: [
            { key: "a", text: "Um token de Bitcoin" },
            { key: "b", text: "Um vídeo colecionável único da NBA" },
            { key: "c", text: "Uma senha da MetaMask" },
            { key: "d", text: "Um e-mail assinado" },
          ],
          correct: "b",
        },
        {
          id: "q5",
          question: "O que diferencia os NFTs de criptomoedas como BTC?",
          options: [
            { key: "a", text: "NFTs podem ser trocados entre si facilmente" },
            { key: "b", text: "NFTs não existem na blockchain" },
            {
              key: "c",
              text: "NFTs são únicos e irrepetíveis",
            },
            { key: "d", text: "NFTs são sempre mais caros" },
          ],
          correct: "c",
        },
        {
          id: "q6",
          question: "O que significa “staking” na Web3?",
          options: [
            { key: "a", text: "Comprar ações de uma empresa" },
            {
              key: "b",
              text: "Deixar criptos bloqueadas para validar a rede e ganhar recompensas",
            },
            { key: "c", text: "Pagar uma assinatura mensal da wallet" },
            { key: "d", text: "Gastar criptos em videogames" },
          ],
          correct: "b",
        },
        {
          id: "q7",
          question: "O que é uma DAO?",
          options: [
            { key: "a", text: "Uma wallet avançada" },
            {
              key: "b",
              text: "Uma organização digital onde as decisões são tomadas coletivamente por voto",
            },
            { key: "c", text: "Uma criptomoeda privada" },
            { key: "d", text: "Um antivírus para proteger criptoativos" },
          ],
          correct: "b",
        },
        {
          id: "q8",
          question: "O que é um airdrop?",
          options: [
            { key: "a", text: "Uma queda repentina no preço de um token" },
            { key: "b", text: "Um app de carteira digital" },
            {
              key: "c",
              text: "Um presente de tokens por participar de um projeto",
            },
            { key: "d", text: "Uma função exclusiva dos NFTs" },
          ],
          correct: "c",
        },
        {
          id: "q9",
          question: "O que significa “yield farming”?",
          options: [
            { key: "a", text: "Criar fazendas virtuais com NFTs" },
            {
              key: "b",
              text: "Procurar as melhores taxas de juros nas plataformas DeFi",
            },
            { key: "c", text: "Hackear smart contracts" },
            { key: "d", text: "Investir apenas em moedas estáveis como USDC" },
          ],
          correct: "b",
        },
        {
          id: "q10",
          question: "O que representa um NFT?",
          options: [
            { key: "a", text: "Um contrato entre bancos" },
            { key: "b", text: "Uma cópia de uma criptomoeda" },
            {
              key: "c",
              text: "Um ativo digital único registrado na blockchain",
            },
            { key: "d", text: "Uma senha para acessar sua wallet" },
          ],
          correct: "c",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: [
        "“O futuro pertence a quem entende a tecnologia… mas também a quem sabe usá-la com propósito.”",
      ],
    },
  ],
};

export default modulo6_pt;
